<div class="flex flex-col items-center justify-center">
	<h3>Please update property type</h3>

	<app-pill class="mx-4 my-3" [leftIcon]="ICON.WARNING" mode="warning">
		<p
			*ngIf="
				!isLegalDescriptionCondoUnit &&
				propertyTypeHardCopy?.type === propertyTypes.CONDO
			"
			class="whitespace-normal text-left"
		>
			A non-condo legal description has been detected. Please update property
			type to continue.
		</p>
		<p
			*ngIf="
				isLegalDescriptionCondoUnit &&
				propertyTypeHardCopy?.type !== propertyTypes.CONDO
			"
			class="whitespace-normal text-left"
		>
			A condo legal description has been detected. Please update property type
			to continue.
		</p>
	</app-pill>

	<app-property-type-selection
		[propertyType]="propertyType"
		(onPropertyTypeChange)="onPropertyChange($event)"
	></app-property-type-selection>

	<div class="flex justify-between w-full mt-4">
		<app-button size="small" (click)="cancel()" btn="secondary"
			>Cancel</app-button
		>
		<app-button
			size="small"
			(click)="update()"
			[disabled]="propertyTypeHardCopy?.type === propertyType?.type"
			>Update</app-button
		>
	</div>
</div>
